import React from 'react';
import ServicePage from '../../components/ServicePage';

const Storage = () => (
  <ServicePage
    seoTitle="Secure Climate-Controlled Storage | Navy Seals Moving"
    seoDescription="Secure, climate-controlled storage in our own warehouse facilities. Ideal between homes, during downsizing, or alongside a long-distance move, handled by the same crew that moves you."
    headerTitle="Storage"
    introTitle="Storage That's Part of Your Move"
    intro={[
      "Sometimes a move needs a pause: closing dates that don't line up, a remodel that isn't finished, or downsizing decisions that shouldn't be rushed. Our storage service exists for exactly those moments.",
      "Your belongings are stored in our own secure, climate-controlled warehouse facilities, with state-of-the-art security, and handled only by our own crews. Because storage and moving are one operation with us, there's no extra handoff: the team that packs your home is the team that stores it and delivers it when you're ready.",
      "Store a few pieces of furniture or an entire household, for a week or for months. Everything stays exactly as you left it."
    ]}
    featuresTitle="Why Store With Your Mover"
    features={[
      {
        icon: 'icon_house',
        title: 'Climate-Controlled Facilities',
        text: 'Stable temperature and conditions protect wood furniture, electronics, artwork, and anything sensitive to heat, cold, or moisture.'
      },
      {
        icon: 'icon_datareport',
        title: 'State-of-the-Art Security',
        text: 'Our own monitored warehouse, not a self-storage unit. Your belongings are protected around the clock.'
      },
      {
        icon: 'icon_group',
        title: 'One Team, No Handoffs',
        text: 'The same crew that packs and moves you handles your storage, so nothing is loaded, unloaded, or transferred by strangers.'
      },
      {
        icon: 'icon_easel',
        title: 'Flexible Timing',
        text: 'Short-term bridge between homes or long-term storage during a transition. Your schedule decides, not ours.'
      }
    ]}
  />
);

export default Storage;
